// *https://www.registers.service.gov.uk/registers/country/use-the-api*
// import fetch from 'cross-fetch';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import {apiPathConfig} from "../utils/config";
import {fetchJson as httpClient} from "../utils/keycloak";
import get from 'lodash/get';

export default function Asynchronous(props) {
    const {
        error = false,
        //value = [],
        setValue,
        setCustomerName=false,
        //defaultValue,
        url,
        getOptionLabel,
        label = '---',
        outputField = 'id',
        searchField = 'search',
        domain = apiPathConfig.getApiUrl(),
    } = props

    const [open, setOpen] = React.useState(false);
    const [valueTyping, setValueTyping] = React.useState('');
    const [options, setOptions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    // const loading = open && options.length === 0;


    // const domain = apiPathConfig.getApiUrl()
    const fetchQuery = `${domain}${url}?limit=15&ordering=-id&skip=0`

    const handleChange = (event) => {
        setValueTyping(event.target.value)
        // debugger
    }
    const handleChangeA = (event, newInputValue) => {
        //console.log('newInputValue======>', newInputValue)
        let res = null
        if(newInputValue){
            if(outputField) res = get(newInputValue, outputField, null)
            else res = newInputValue
            if(setCustomerName) setCustomerName(newInputValue)
        }
        setValue(res)
        /*if (newInputValue && newInputValue[outputField] !== undefined) setValue(newInputValue[outputField])
        else setValue(null)*/
    }

    React.useEffect(() => {
        (async () => {
            setLoading(true)
            const response = await httpClient(`${fetchQuery}&${searchField}=${valueTyping}`);
            // await sleep(1e3); // For demo purposes.
            const res = response.json;
            const results = res.results
            // debugger
            setOptions(Object.keys(results).map((key) => results[key]));
            setLoading(false)
        })();
    }, [setLoading, fetchQuery, valueTyping, searchField]);

    // React.useEffect(() => {
    //     if (!open) {
    //         setOptions([]);
    //     }
    // }, [open]);

    return (
        <Autocomplete
            //defaultValue={defaultValue}
            id={`${url}-id-autocomplete`}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            // getOptionSelected={(option, value) => option.name === value.name}
            getOptionLabel={getOptionLabel}
            options={options}
            filterOptions={(option, state) => {//Берет, все что пришло, не применяя фильтр
                return option
            }}
            onChange={handleChangeA}
            // onSelect={handleChangeA}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    error={error}
                    value={valueTyping}
                    onChange={handleChange}
                    size={"small"}
                    label={label}
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        //style: {padding: "0px"},
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}